(() => {
  const root = window.Shopify?.routes?.root || '/';
  const route = (path) => `${root}${path}`.replace(/\/+/g, '/');
  const blockedDestination = (value = '') => {
    try {
      const url = new URL(value, window.location.origin);
      return /\/(cart|checkout)(\/|$)/.test(url.pathname);
    } catch (_error) {
      return /\/(cart|checkout)(\/|$)/.test(value);
    }
  };

  const openWaitlist = () => {
    const trigger = document.querySelector('[data-newsletter-open]');
    if (trigger) trigger.click();
  };

  const clearCart = () => {
    window.fetch(route('cart/clear.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).catch(() => {});
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (blockedDestination(form.action) || form.querySelector('[name="checkout"], [name="add"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearCart();
      openWaitlist();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || !blockedDestination(link.href)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clearCart();
    openWaitlist();
  }, true);

  clearCart();
})();
